import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import MindOverCity from '@/components/MindOverCity';
import FocusDrive from '@/components/FocusDrive';
import PeaceDefender from '@/components/PeaceDefender';
import CalmCommand from '@/components/CalmCommand';
import BoxBreathing from '@/components/BoxBreathing';
import LevelUnlockFlourish from '@/components/lounge/LevelUnlockFlourish';

/**
 * Chrome-free, public full-screen host for a single Lounge experience.
 * Used by the native mobile app (react-native-webview) to render the EXACT
 * same games as the web app, inline inside a native screen. No nav, no auth,
 * no AppShell — the games are 100% client-side (localStorage + static levels).
 */
const GAMES = {
  'mind-over-city': MindOverCity,
  'focus-drive': FocusDrive,
  'peace-defender': PeaceDefender,
  'calm-command': CalmCommand,
  'box-breathing': BoxBreathing,
};

export default function EmbeddedGame() {
  const { game } = useParams();
  const Game = GAMES[game];

  // Bridge: forward the web `lounge:level-unlocked` event to the native app
  // (react-native-webview) so it can play a soft chime + light haptic. Web-only
  // behaviour is unchanged — postMessage is only sent when hosted in the RN WebView
  // (checked at fire-time so it's robust to bridge-injection timing).
  useEffect(() => {
    const onUnlock = (e) => {
      const level = e?.detail?.level;
      const rnw = typeof window !== 'undefined' ? window.ReactNativeWebView : undefined;
      if (!level || !rnw) return;
      try {
        rnw.postMessage(JSON.stringify({ type: 'lounge:level-unlocked', level }));
      } catch {
        /* ignore */
      }
    };
    window.addEventListener('lounge:level-unlocked', onUnlock);
    return () => window.removeEventListener('lounge:level-unlocked', onUnlock);
  }, []);

  if (!Game) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0B192C', color: '#fff' }}>
        Game not found.
      </div>
    );
  }

  return (
    <div
      data-embed={game}
      style={{ minHeight: '100vh', background: '#0B192C', padding: '10px 10px 24px', boxSizing: 'border-box' }}
    >
      <Game />
      <LevelUnlockFlourish />
    </div>
  );
}
